module.exports = __webpack_public_path__ + "static/media/Calendar-New-White.874b30a1.svg";